






















































































































































import Vue from 'vue'
import ViewTagModal from '@/views/console/gateway-list/components/ViewTagModal.vue'
import {hardwareType} from "@/views/console/gateway-list/components/data";
import {dic} from '@/views/iot-console/gateway-admin/components/GatewayList.vue'
import {IotServerStatusServiceProxy} from "@/service-proxies/app-v2/iotmodel-storage.service-proxies";
import {
  GatewayServiceProxy,
  GatewaySimServiceProxy,
  IotAppMethodServiceProxy,
  ServerStopDTO
} from "@/service-proxies/app-v2/iot-console.service-proxies";

const isp = new IotServerStatusServiceProxy()
const iamsp = new IotAppMethodServiceProxy()
const gsp = new GatewayServiceProxy()
const simProxy = new GatewaySimServiceProxy()

let processMap = {
  1: "RemoteTerminal",
  2: "extranet.linux.endpoint.out",
  3: "com.wimi.system:vnc.server",
  4: "DNCFTPServer.out",
  5: "DncSyncproc,Dncsyncproc",
  6: "smbd"
}

let fileNameMap = {
  1: "remoteterminalstart.sh",
  2: "extranet_v2_auto.sh",
  4: "DNCFTPServer.out",
  5: "DncSyncproc",
  6: "smbd"
}

let paramsMap = {
  1: "",
  2: "",
  3: "",
  4: "",
  5: "127.0.0.1 M001 123456 /tmp/dncfs &",
  6: "-D"
}

let typeToPath = {
  "s1": {
    "remote":"/home/Program/IoT",
    "extranet": "/home/etc",
    "dncFtp": "/home/Program/FTPService",
    "dncSyncproc": "/home/Program/FTPService",
    "smbd": "/usr/local/samba/sbin"
  },
  "s2": {
    "remote":"/home/Program/IoT",
    "extranet":"/home/Scripts",
    "dncFtp": "/home/Program/FTPService",
    "dncSyncproc": "/home/Program/FTPService",
    "smbd": "/usr/local/samba/sbin"
  },
  "h2": {
    "remote":"/userdata/IoT",
    "extranet":"/home/NetWorkScripts",
    "dncFtp": "/opt/FTPService",
    "dncSyncproc": "/home/Program/WebService",
    "smbd": "/usr/local/samba/sbin"
  },
  "mtpad_linux": {
    "remote":"/opt/IoT",
    "extranet":"/usr/bin",
    "dncFtp": "/opt/ftp",
    "dncSyncproc": "/opt/ftp",
    "smbd": "/usr/sbin"
  },
  "mtpad_android": {
    "remote":"/home/android/IoT",
    "extranet":"/home/android",
    "dncFtp": "/home/android/ftp",
    "dncSyncproc": "/home/android/ftp",
    "smbd": "/etc/init.d"
  }
}

const getOperator=(iccid)=>{
  if(!iccid){
    return '--';
  }
  const prix = iccid.substr(0,6);

  const yidong = ['898600','898602','898604','898607']
  const liantong= ['898601','898606','898609']
  const dianxin=['898603','898611']
  
  if(yidong.includes(prix)){
    return '移动'
  }

  if(liantong.includes(prix)){
    return '移动'
  }

  if(dianxin.includes(prix)){
    return '电信'
  }

  return '--';

}

export default Vue.extend({
  components: {
    ViewTagModal,
  },
  props: {
    gateway: {
      type: Object,
      default() {
        return {}
      }
    },
    tenants: {},
    desktopDisabled: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      userVisibleStatus: 0,
      authorizeCount: 0,
      dmpVersion: '',
      dncFtpStatus: '0',
      dncSyncprocStatus: '0',
      extranetStatus: '0',
      remoteTerminalStatus: '0',
      smbdStatus: '0',
      vncServerStatus: '0',
      iccid: '',
      imei:'',
      imsi:'',
      rssi:'',
      operator: undefined,
      spin: false,
      notRunning: "未运行",
      running: "运行中",
      reboot: "重启",
      startUp: "启动",
      stop: "停止",
      disabled: false,
      timeOut : null,
      interval:null
    }
  },
  computed: {
    gatewayCode() {
      return this.gateway?.code || '--'
    },
    hardwareType() {
      let obj = hardwareType.find(item => item.value === this.gateway.hardwareType)
      if (obj) {
        return obj.label
      } else {
        return 's1'
      }
    },
    tenantName() {
      if (!this.gateway.tenantIds) {
        return ''
      }
      var tenantNameList = []
      var tenantIds = this.gateway.tenantIds
      var tenantIdArr = tenantIds.split(",")
      if (tenantIdArr.length > 0) {
        for (var tenantId of tenantIdArr) {
          var obj = this.tenants.find(item => item.value === tenantId)
          if (obj) {
            tenantNameList.push(obj.value + '/' + obj.code + '/' + obj.label)
          }
        }
      }
      return tenantNameList.join("\r\n")
    },
    showTenant() {
      return this.tenantName
    },
    gatewayIsOnline() {
      return this.gateway?.isOnline || false
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.getServerStatus()
      this.getSimIccid()
      this.getSimImei()
      this.getSimImsi()
      this.getSimRssi()
    })
  },
  created() {
    this.setIntervalFun()
  },
  destroyed() {
    if (this.interval){
      window.clearInterval(this.interval)
    }
  },
  watch: {
    gateway: {
      handler(newVal, oldVal) {
        this.$nextTick(() => {
          this.getServerStatus()
          this.getSimIccid()
          this.getSimImei()
          this.getSimImsi()
          this.getSimRssi()
        })
      }

    },
    iccid:{
      handler(newVal){
        this.operator = getOperator(newVal)
      }
    }
  },
  methods: {

    // 查看标签
    viewTag(record: any) {
      this.currentGatewayId = record.id
      this.$nextTick(() => {
        this.$refs.viewTagModal.openViewDialog()
      })
    },
    getImageUrl(gatewayType) {
      const url = dic[gatewayType];
      console.log('gatewayType',gatewayType);
      return url ?? "/images/gateway/s1.png";
    },
    getServerStatus() {
      if (!(this.gateway && this.gatewayIsOnline)) {
        return
      }
      isp.getServerStatus(this.gatewayCode).then((res) => {
        if (res) {
          this.authorizeCount = res.authorizeCount ? res.authorizeCount : 0
          this.dmpVersion = res.dmpVersion ? res.dmpVersion : ''
          this.dncFtpStatus = res.dncFtpStatus ? res.dncFtpStatus : '0'
          this.dncSyncprocStatus = res.dncSyncprocStatus ? res.dncSyncprocStatus : '0'
          this.extranetStatus = res.extranetStatus ? res.extranetStatus : '0'
          this.remoteTerminalStatus = res.remoteTerminalStatus ? res.remoteTerminalStatus : '0'
          this.smbdStatus = res.smbdStatus ? res.smbdStatus : '0'
          this.vncServerStatus = res.vncServerStatus ? res.vncServerStatus : '0'
        }
      })
    },
    getSimIccid() {
      if (!this.gateway.id) {
        return
      }
      gsp.getGatewayIccid(this.gateway.id).then((res) => {
        if (res) {
          if(res === "调用失败, APP不在线"){
            this.$message.error(res)
            return
          }
          this.iccid = res
        }
      })
    },
    refreshSimIccid() {
      if (!this.gatewayIsOnline) {
        this.$message.error("网关不在线")
        return;
      }
      if (!this.gateway.id) {
        return
      }
      this.spin = true
      this.disabled = true
      simProxy.refreshGatewayIccid(this.gateway.id).then((res) => {
        if (res) {
          if(res === "调用失败, APP不在线"){
            this.$message.error(res)
            return
          }
          this.iccid = res
        }
      }).finally(() => {
        this.spin = false
        this.disabled = false
      })
    },

    getSimImei() {
      if (!this.gateway.id) {
        return
      }
      simProxy.getGatewayImei(this.gateway.id).then((res) => {
        if (res) {
          if(res === "调用失败, APP不在线"){
            this.$message.error(res)
            return
          }
          this.imei = res
        }
      })
    },
    refreshSimImei() {
      if (!this.gatewayIsOnline) {
        this.$message.error("网关不在线")
        return;
      }
      if (!this.gateway.id) {
        return
      }
      this.spin = true
      this.disabled = true
      simProxy.refreshGatewayImei(this.gateway.id).then((res) => {
        if (res) {
          if(res === "调用失败, APP不在线"){
            this.$message.error(res)
            return
          }
          this.imei = res
        }
      }).finally(() => {
        this.spin = false
        this.disabled = false
      })
    },

    getSimImsi() {
      if (!this.gateway.id) {
        return
      }
      simProxy.getGatewayImsi(this.gateway.id).then((res) => {
        if (res) {
          if(res === "调用失败, APP不在线"){
            this.$message.error(res)
            return
          }
          this.imsi = res
        }
      })
    },
    refreshSimImsi() {
      if (!this.gatewayIsOnline) {
        this.$message.error("网关不在线")
        return;
      }
      if (!this.gateway.id) {
        return
      }
      this.spin = true
      this.disabled = true
      simProxy.refreshGatewayImsi(this.gateway.id).then((res) => {
        if (res) {
          if(res === "调用失败, APP不在线"){
            this.$message.error(res)
            return
          }
          this.imsi = res
        }
      }).finally(() => {
        this.spin = false
        this.disabled = false
      })
    },


    getSimRssi() {
      if (!this.gateway.id) {
        return
      }
      simProxy.getGatewayRssi(this.gateway.id).then((res) => {
        if (res) {
          if(res === "调用失败, APP不在线"){
            this.$message.error(res)
            return
          }
          this.rssi = res
        }
      })
    },
    refreshSimRssi() {
      if (!this.gatewayIsOnline) {
        this.$message.error("网关不在线")
        return;
      }
      if (!this.gateway.id) {
        return
      }
      this.spin = true
      this.disabled = true
      simProxy.refreshGatewayRssi(this.gateway.id).then((res) => {
        if (res) {
          if(res === "调用失败, APP不在线"){
            this.$message.error(res)
            return
          }
          this.rssi = res
        }
      }).finally(() => {
        this.spin = false
        this.disabled = false
      })
    },

    async serverStop(processNum) {
      if (!this.gateway.id) {
        return
      }
      let pName = processMap[processNum].split(",")
      let result = []
      for (var p of pName) {
        let params = {
          gatewayCode: this.gatewayCode,
          serverName: p
        }
        const ps = new ServerStopDTO()
        ps.init(params)
        await gsp.iotServerStop(ps).then((res) => {
          if (res) {
            result = [res]
          }
        })
      }
      if (result.indexOf(true) != -1) {
        this.$message.success("操作成功")
        this.timeOutFun()
      }
    },
    async serverStart(processNum) {
      if (!this.gatewayIsOnline) {
        this.$message.error("网关不在线")
        return;
      }
      let WorkPath = ''
      let param = paramsMap[processNum]
      if (processNum === 1){
        WorkPath = typeToPath[this.gateway.hardwareType].remote
      }
      if (processNum === 2){
        WorkPath = typeToPath[this.gateway.hardwareType].extranet
      }
      if (processNum === 4){
        WorkPath = typeToPath[this.gateway.hardwareType].dncFtp
      }
      if (processNum === 5){
        WorkPath = typeToPath[this.gateway.hardwareType].dncSyncproc
      }
      if (processNum === 6){
        WorkPath = typeToPath[this.gateway.hardwareType].smbd
        if (this.gateway.hardwareType === 'mtpad_android'){
          param = 'start'
        }
      }

      if (!this.gateway.id) {
        return
      }
      let params: any = {
        appCode: 0,
        methodId: 11,
        isAsync: true,
        gatewayCode: this.gatewayCode,
        execParamMap: {
          Name: fileNameMap[processNum],
          WorkPath: WorkPath,
          Params: param,
        }
      }
      console.log("params", params)

      try {
        let res = await iamsp.execMethod(params)
        if (res && res.message && res.message !== 'null') {
          if (res.message === "调用失败, APP不在线") {
            this.$message.error(res.message)
            return
          }
          let str = JSON.parse(res.message)
          if (str.hasOwnProperty('responseCode') && str.responseCode === 0) {
            this.$message.success("操作成功")
            this.timeOutFun()
            return
          }
        }
        this.$message.error("操作失败")
      } catch (e) {
        console.log(e)
      }
    },
    restart(processNum){
      this.serverStop(processNum)
      this.serverStart(processNum)
    },
    // serverStart() {
    //   this.$message.error("暂未实现")
    // },

    //定时刷新状态
    setIntervalFun(){
      this.interval = setInterval(()=>{
        this.getServerStatus()
      },10*1000)
    },
    timeOutFun(){
      this.getServerStatus()
    }
  }
})
